import { CmAuthDirective } from '../../core/auth/cm-auth.directive'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NgForTrackByIndexDirective, NgForTrackByIdDirective, NgForTrackByPropertyDirective } from './ng-for-track-by.directive'
import { StopEventDirective } from './stop-event.directive'
import { AutofocusDirective } from './autofocus.directive'
import { OffClickDirective } from './off-click.directive'
import { ShowModeDirective } from './show-mode.directive'
import { EditModeDirective } from './edit-mode.directive'

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        AutofocusDirective,
        CmAuthDirective,
        NgForTrackByIdDirective,
        NgForTrackByIndexDirective,
        NgForTrackByPropertyDirective,
        StopEventDirective,
        OffClickDirective,
        ShowModeDirective,
        EditModeDirective
    ],
    exports: [
        AutofocusDirective,
        CmAuthDirective,
        NgForTrackByIdDirective,
        NgForTrackByIndexDirective,
        NgForTrackByPropertyDirective,
        StopEventDirective,
        OffClickDirective,
        ShowModeDirective,
        EditModeDirective,
    ],
})
export class DirectivesUpgradedModule {
}